
import PanelFooter from './PanelFooter.jsx';

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FullScreenPanel/PanelFooter/index.js